/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

export { BrowserWebSocket } from './browserWebSocket';
export { WebSocketClient } from './browserWebSocketClient';
/** @internal */
export { WebSocketTransport } from './webSocketTransport';
